import { cva } from 'class-variance-authority';
export const imageStyling = cva('object-cover', {
    variants: {
        size: {
            xs: 'min-w-5 min-h-5 size-5',
            sm: 'min-w-8 min-h-8 size-8',
            md: 'min-w-12 min-h-12 size-12',
            lg: 'min-w-12 min-h-12 size-12 sm:min-w-16 sm:min-h-16 sm:size-16',
        },
        rounding: {
            full: 'rounded-full',
        },
    },
    defaultVariants: {
        size: 'sm',
        rounding: 'full',
    },
});
